<template>
  <el-container>
    <img class="banner" src="../assets/img/help.jpg" />
    <div class="bg-box">
      <el-aside width="315px">
        <left-menu :menuList="menuList" :activeMenuIndex="activeMenu" @activeMeun="activeMeun"></left-menu>
      </el-aside>
      <div class="right-text">
        <div class="title1" v-show="activeTextEng">{{activeText}}</div>
        <div class="title2" v-show="activeTextEng">{{activeTextEng}}</div>
        <span v-show="activeTextEng">
          <el-divider></el-divider>
        </span>
        <div v-if="activeStr=='法律法规'">
          <div class="laws-main">
            <div class="laws-main-box" v-for="(item,index) in lawsList" :key="index">
              <el-row>
                <el-col :span="13" :offset="1">《{{item.title}}》</el-col>
                <el-col :span="3" :offset="7">
                  <el-button
                    @click="handleClick(item)"
                    type="text"
                    size="small"
                    style="color:red;font-size: 16px;"
                  >查看详情</el-button>
                </el-col>
              </el-row>
            </div>
            <div class="block">
              <el-pagination
                @size-change="SizeChange"
                @current-change="CurrentChange"
                :page-size="pageNum"
                background
                layout="prev, pager, next, jumper, total"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "help",
  components: {
    leftMenu
  },
  data() {
    return {
      menuList: ["法律法规"],
      activeText: "",
      activeStr: "",
      pjtid: "",
      activeMenu: 0,
      pageNum: 10,
      total: 0,
      lawsList: [

      ],
      RPpageNum: 10,
      RPtotal: 2,
      RegulatoryPolicy: [
        {
          title: "保险经纪机构监管规定",
          text: "保险经纪机构监管规定"
        },
        {
          title: "保险经纪机构基本服务标准",
          text: "保险经纪机构基本服务标准"
        }
      ],
      CommonProblem: [
        {
          title: "什么是保险经纪公司?",
          text:
            "保险经纪公司是代表投保人利益与保险公司洽谈保险业务的第三方,在业务达成之后,可向保险公司收取相应的手续费。从本质上说,保险经纪公司是客户的利益代表,为其提供保险中介服务,同时也为客户提供风险管理，风险方案等服务。"
        },
        {
          title: "保险经纪公司靠谱吗?",
          text:
            "通过保险经纪公司购买保险产品，最后承保公司还是保险公司，和在保险公司购买的保险是一样的。保险经纪公司能够以客户的角度为客户选择合适的保险产品,并提供相应的专业服务,所以通过保险经纪公司购买保险是靠谱的，更加省心。"
        },
        {
          title: "福保保险经纪公司怎么样?",
          text:
            "辽宁福保保险经纪公司是一家全国性的保险公司，成立于2006年，于2019年4月被福佳集团收购，纳入集团金融板块旗下，公司的管理团队全部来自于大型保险机构，拥有超过10年的管理经验，目前公司为客户提供包括财产险，寿险，团险业务在内的全体系产品。同时福保经纪通过整合各类资源，建立专业，稳健，高效的保险服务团队和有效的风险防控机制，为客户的人身风险，财产风险，责任风险以及企业运营风险的防控与转嫁提出专业意见和解决方案。"
        }
      ]
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.query.id) {
        this.activeStr = this.$route.query.id;
        if (this.$route.query.id == "法律法规") {
          this.activeMenu = 0;
        } else if (this.$route.query.id == "监管政策") {
          this.activeMenu = 1;
        } else if (this.$route.query.id == "常见问题") {
          this.activeMenu = 2;
        }
      }
      window.scrollTo(0, 0);
    });
  },
  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "法律法规":
          return 'LAWS AND REGULATIONS'
          break;
        case "监管政策":
          //return 'INFORMATION DISCLOSURE'
          break;
        case "常见问题":
          return "COMMON PROBLEM";
          break;
        default:
          break;
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.id) {
      this.activeStr = to.query.id;
      if (to.query.id == "法律法规") {
        this.activeMenu = 0;
      } else if (to.query.id == "监管政策") {
        this.activeMenu = 1;
      } else if (to.query.id == "常见问题") {
        this.activeMenu = 2;
      }
    }
    next();
  },
  watch: {
    "$route.query"() {
      //监听路由不变参数改变
    }
  },
  methods: {
    activeMeun(data) {
      this.activeText = data;
      this.activeStr = data;
    },
    //法律法规-查看详情
    handleClick(row) {
      this.$router.push({
        path: "/detail",
        query: { id: row.title, father: "help" }
      });
    },
    //监管政策-查看详情
    RPhandleClick(row) {
      this.$router.push({
        path: "/detail",
        query: { id: row.title, father: "help" }
      });
    },
    //法律法规-每页条数设置
    SizeChange(str) {
      console.log(str);
    },
    //法律法规-分页跳整
    CurrentChange(str) {
      console.log(str);
    },
    //监管政策-每页条数设置
    RPSizeChange(str) {
      console.log(str);
    },
    //监管政策-分页跳整
    RPCurrentChange(str) {
      console.log(str);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 35px;
}
.el-container {
  flex-wrap: wrap;
}
.banner {
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.bg-box {
  width: 100%;
  min-width: 1050px;
  box-sizing: border-box;
  display: flex;
  margin: 0 15%;
  .right-text {
    width: 100%;
    text-align: left;
    margin: 0 0 20px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: $green !important;
  color: #fff;
}
/deep/ .el-pagination.is-background .el-pager li:hover {
  color: $green !important;
}
.laws-main {
  max-width: 964px;
  min-width: 600px;
  max-height: 830px;
  margin: 0 10px 100px 0;
}
.laws-main-box {
  max-width: 964px;
  min-width: 600px;
  height: 78px;
  line-height: 78px;
  border-width: 0px;
  border: 2px solid $font-color-gary3;
  margin-bottom: 10px;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.block {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  text-align: center;
}
.itemtitle {
  margin-top: 5px;
  font-size: 20px;
  height: 25px;
  color: #000;
  margin-bottom: 5px;
}
.itemtext {
  font-size: 18px;
  color: #a9a9a9;
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/help.vue